import React from "react"
import { Box, Flex, Grid, Heading, Text, Container } from "@theme-ui/components"
import RichContentStructuredText from "../richContentStructuredText"
import { GatsbyImage } from "gatsby-plugin-image"

const ImageAndText = ({ title, body, image }) => {
  return (
    <Box sx={{ mb: [4, 4, 4, 5] }}>
      <Grid columns={[1, 1, 2, 2]} gap={0}>
        <Container
          sx={{
            paddingRight: [3, 3, 8, 9],
            p: { fontSize: [2, 3, 4] },
            gridRow:[2,2,1]
          }}
        >
          <Flex sx={{ height: "100%", alignItems: "flex-end" }}>
            <Box
              sx={{
                p: {
                  fontSize: [2, 3,4],
                  fontFamily: "roc",
                },
              }}
            >
              <Heading
                as="h2"
                variant="h2"
                sx={{ mb: [3, 4, 4, 4], mt: 0, color:"dark", textTransform: "uppercase" }}
              >
                {title}
              </Heading>
              <RichContentStructuredText text={body} />
            </Box>
          </Flex>
      </Container>
        {image && (
          <Box>
            <GatsbyImage image={image.gatsbyImageData} alt="" />
          </Box>
        )}
      </Grid>
    </Box>
  )
}

export default ImageAndText
